import React, { Component } from 'react';
import styled from 'styled-components';

const InputGroupStyled = styled.div`
  margin-bottom: 15px;
  input {
    margin-bottom: 0;
  }
  label {
    margin-top: 0;
  }
`;

export const InputGroup: React.FC<any> = props => {
  return <InputGroupStyled {...props}>{props.children}</InputGroupStyled>;
};

export default InputGroup;
